import LineLabel from '@presentation/assets/route/line-label.png'
import TocIcon from '@presentation/assets/route/TOC.png'
import TodIcon from '@presentation/assets/route/TOD.png'
import WaypointLabelIcon from '@presentation/assets/route/waypoint-label.png'
import { CircleLayerSpecification, LineLayerSpecification, SymbolLayerSpecification } from 'mapbox-gl'
import { DefaultTheme } from 'styled-components'

import { MAP_SYMBOL_PRIORITIES } from './GeojsonUtils'

export { TocIcon, TodIcon }

export const routeWaypointHighlightedCirclePaint = (theme: DefaultTheme): CircleLayerSpecification['paint'] => ({
  'circle-radius': 20,
  'circle-color': theme.colors.secondary,
  'circle-stroke-width': 2,
  'circle-stroke-color': theme.colors.primary,
  'circle-opacity': 0.2
})

export const routeWaypointHighlightedPointPaint = (theme: DefaultTheme): CircleLayerSpecification['paint'] => ({
  'circle-radius': 7,
  'circle-color': theme.colors.primary,
  'circle-stroke-width': 1.3,
  'circle-stroke-color': theme.colors.secondary,
  'circle-opacity': 1
})

export const routeWaypointCirclePaint = (theme: DefaultTheme): CircleLayerSpecification['paint'] => ({
  'circle-radius': ['get', 'radius'],
  'circle-color': [
    'match',
    ['get', 'state'],
    'default',
    theme.colors.primary,
    'current',
    theme.colors.primaryL2,
    'past',
    theme.colors.neutralL2,
    theme.colors.primary
  ],
  'circle-stroke-width': 1.2,
  'circle-stroke-color': theme.colors.secondary,
  'circle-opacity': 1
})

export const routeWaypointLabelLayout = (): SymbolLayerSpecification['layout'] => ({
  'text-field': ['get', 'code'],
  'text-size': 12,
  'text-justify': 'center',
  'text-font': ['Open Sans Semibold'],
  'text-offset': [0, -1.65],

  'text-rotation-alignment': 'viewport',
  'text-keep-upright': true,
  'icon-keep-upright': true,
  'icon-rotation-alignment': 'viewport',
  'symbol-sort-key': ['get', 'priority'],
  'symbol-z-order': 'source',
  'text-ignore-placement': true,

  'icon-text-fit': 'both',
  'icon-image': WaypointLabelIcon,
  'icon-text-fit-padding': [5, 10, 10, 10]
})

export const routeWaypointLabelPaint = (theme: DefaultTheme): SymbolLayerSpecification['paint'] => ({
  'text-color': theme.colors.neutralL5,
  'icon-opacity': ['get', 'labelOpacity'],
  'text-opacity': ['get', 'textOpacity']
})

export const routeLinePaint = (theme: DefaultTheme): LineLayerSpecification['paint'] => ({
  'line-width': 5,
  'line-color': [
    'match',
    ['get', 'state'],
    'default',
    theme.colors.primary,
    'current',
    theme.colors.primaryL2,
    'past',
    theme.colors.neutralL2,
    theme.colors.primary
  ],
  'line-opacity': 0.95
})

export const routeLineRightBorderPaint = (theme: DefaultTheme): LineLayerSpecification['paint'] => ({
  'line-width': 1.5,
  'line-color': theme.colors.secondary,
  'line-offset': 3,
  'line-opacity': ['match', ['get', 'state'], 'past', 0.75, 0.85]
})

export const routeLineLeftBorderPaint = (theme: DefaultTheme): LineLayerSpecification['paint'] => ({
  'line-width': 1.5,
  'line-color': theme.colors.secondary,
  'line-offset': -3,
  'line-opacity': ['match', ['get', 'state'], 'past', 0.75, 0.85]
})

export const routeLineLabelLayout = (): SymbolLayerSpecification['layout'] => ({
  'text-field': ['get', 'label'],
  'text-rotate': ['get', 'headingText'],
  'text-size': 12.5,
  'text-justify': 'center',
  'text-font': ['Open Sans Bold'],
  'text-rotation-alignment': 'map',
  'text-offset': [0, 0],
  'icon-text-fit': 'both',

  'text-ignore-placement': true,
  'text-allow-overlap': true,
  'icon-rotation-alignment': 'map',
  'symbol-sort-key': MAP_SYMBOL_PRIORITIES.ROUTE_LENGTH_HEADING,

  'icon-image': LineLabel,
  'icon-rotate': ['get', 'heading'],
  'icon-text-fit-padding': [2, 13, 2, 6]
})

export const routeLineLabelDefaultPaint = (theme: DefaultTheme): SymbolLayerSpecification['paint'] => ({
  'text-color': theme.colors.neutralL4
})
